import { useVariant } from '@unleash/proxy-client-react';
import { useSelector } from 'react-redux';

import type { AppState } from 'types/app';
import { selectUnleashToggle } from 'selectors/features';
import useMartyContext from 'hooks/useMartyContext';

interface UseUnleashKillswitchOptions {
  featureFlag: string;
  isZapposOnly?: boolean;
}

export const useUnleashKillswitch = ({ featureFlag, isZapposOnly = true }: UseUnleashKillswitchOptions) => {
  useVariant(featureFlag);

  const {
    marketplace: { is6pm }
  } = useMartyContext();
  const isKillswitchOn = useSelector((state: AppState) => selectUnleashToggle(featureFlag, state))?.enabled;

  if (isZapposOnly && is6pm) {
    return { isKillswitchOn: false };
  }

  return { isKillswitchOn };
};
